<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tHsdh0/tc-custom/9783958642935_IMGJPG_FrontCover_0.jpg?1702957676293" alt="This image is the cover for the book Annas Ehe, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Annas Ehe, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Ida Boy-Ed (* 17. April 1852 in Bergedorf (heute zu Hamburg); † 13. Mai 1928 in Lübeck-Travemünde; geboren als Ida Cornelia Ernestina Ed) war eine deutsche Schriftstellerin und Salonière. Ida Boy-Ed verfasste über 70 Romane und Erzählbände und beeinflusste mit ihrem Lübecker Salon das kulturelle Leben von Lübeck nachhaltig. Sie war 1901 nach Erscheinen der Buddenbrooks eine Förderin des jungen Thomas Mann. Genauso förderte sie nachhaltig die Dirigenten Wilhelm Furtwängler und Hermann Abendroth in seiner Lübecker Zeit. (Auszug aus Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ida Boy-Ed
      </h2>
      
      <p class="authorDescription body article">Ida Boy-Ed, geboren als Ida Cornelia Ernestina Ed, (* 17. April 1852 in Bergedorf; † 13. Mai 1928 in Lübeck-Travemünde) war eine deutsche Schriftstellerin und Salonnière.(Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB Ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e0c67d0